<template>
	<div style="height: 100%;display: flex;justify-content: center;align-items: center;">
		<div style="height: 100%;">
			<div class="item-message d-flex a-center j-sb" 
			style="background: #f4f4f4;box-sizing: border-box;padding: 0 83px 0 70px;font-size: 16px;">
				<div>时间</div>
				<div>内容</div>
				<div>操作</div>
			</div>
			<div style="height: 70%;overflow-y: scroll;">
				<div v-if="messageList.length" v-for="(item,index) in messageList" :key="index" class="item-message d-flex a-center j-sb">
					<div>{{$getDate(item.add_time)}}</div>
					<div>{{item.content}}</div>
					<div @click="leave_message_del(item)" style="cursor: pointer;">删除</div>
				</div>
				<div v-else style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;">
					<img style="width: 150px;height: 150px;" src="../../assets/Home/zwsj@2x.png" />
				</div>
			</div>
			
			<div class="d-flex j-center">
				<el-pagination  @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10,15]"
					:current-page.sync="currentPage" :page-size="pageSize" layout="sizes,prev, pager, next, total,jumper" :total="total_records">
				</el-pagination>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default{
		data() {
			return{
				currentPage: 1, //初始页
				pageSize : 10,
				total_records : 0,
				messageList:[]
			}
		},
		created() {
			this.enterprise_msg_list()
		},
		methods:{
			handleSizeChange(size) {
				this.pageSize = size;
				this.enterprise_msg_list()
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.enterprise_msg_list()
			},
			enterprise_msg_list(){
				let params = {
					act:'enterprise_msg_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					size:this.pageSize,
					page:this.currentPage
				}
				this.$api.enterprise_msg_list(params).then((res)=>{
					this.messageList = []
					if(res.code == 0){
						this.messageList = res.data
						this.total_records = res.total_records
					}
				})
			},
			leave_message_del(item){
				let params = {
					act:'enterprise_msg_del',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					id:item.id
				}
				this.$api.leave_message_del(params).then((res)=>{
					if(res.code == 0){
						this.currentPage = 1
						this.enterprise_msg_list()
						this.$message({
							showClose: false,
							message: '删除成功',
							type: 'success',
							offset: 350
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			}
		}
	}
</script>

<style >
	.item-message{
		width: 1170px;
		height: 60px;
		background: #FFFFFF;
		border-radius: 4px;
		padding: 0 83px 0 30px;
		font-size: 12px;
		box-sizing: border-box;
	}
</style>
